import { useMemo } from "react";

import type { ScreenMembersOnResetPasswordSuccess } from "@auth0/auth0-acul-js";
import ResetPasswordSuccessInstance from "@auth0/auth0-acul-js/reset-password-success";

export const useResetPasswordSuccessManager = () => {
  const resetPasswordSuccessInstance = useMemo(
    () => new ResetPasswordSuccessInstance(),
    []
  );

  const { screen, transaction } = resetPasswordSuccessInstance;
  const { texts } = screen;

  return {
    resetPasswordSuccessInstance,
    texts: (texts || {}) as ScreenMembersOnResetPasswordSuccess["texts"],
    errors: resetPasswordSuccessInstance.getError(),
    loginLink: screen.links?.login || null,
    transactionState: transaction.state || "",
  };
};
